import React from "react";
import { useLang } from "@/i18n";
import { Reveal, MaskedLineOnScroll, CountUp } from "@/lib/motion";

export default function About() {
  const { t } = useLang();
  return (
    <section id="about" data-testid="about-section" className="relative py-28 lg:py-40 max-w-[1400px] mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal>
            <span className="font-accent text-xs md:text-sm tracking-[0.25em] uppercase text-[#D4AF37]">{t.about.overline}</span>
          </Reveal>
          <div className="mt-8 relative">
            <span className="font-display font-semibold text-[26vw] sm:text-[20vw] lg:text-[13vw] leading-none tracking-tighter text-transparent [-webkit-text-stroke:1px_rgba(212,175,55,0.4)] block select-none">
              1970
            </span>
            <Reveal delay={0.2} className="mt-6">
              <div className="flex flex-col gap-3">
                {t.about.stats.map((s) => (
                  <div key={s.l} className="flex items-baseline justify-between border-b border-white/10 pb-3" data-testid="about-stat">
                    <span className="font-display text-3xl md:text-4xl text-white">{s.n}</span>
                    <span className="font-accent text-xs uppercase tracking-widest text-zinc-500">{s.l}</span>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-7 lg:pt-16">
          <h2 className="font-display text-3xl md:text-5xl font-medium tracking-tight text-white leading-[1.05]">
            <MaskedLineOnScroll>{t.about.title}</MaskedLineOnScroll>
          </h2>
          <Reveal delay={0.15} className="mt-10 space-y-6 max-w-2xl">
            <p className="text-base md:text-lg text-zinc-400 leading-relaxed">{t.about.p1}</p>
            <p className="text-base md:text-lg text-zinc-400 leading-relaxed">{t.about.p2}</p>
          </Reveal>

          <div className="mt-14">
            <Reveal>
              <span className="font-accent text-xs uppercase tracking-widest text-zinc-500">{t.about.heritageTitle}</span>
            </Reveal>
            <div className="mt-6 grid sm:grid-cols-3 gap-px bg-white/10 border border-white/10" data-testid="heritage-timeline">
              {t.about.heritage.map((h, i) => (
                <Reveal key={h.t} delay={i * 0.1} className="bg-[#0A0A0A] p-6">
                  <span className="font-display text-3xl text-[#D4AF37]">{h.y}</span>
                  <h3 className="mt-3 font-display text-xl text-white">{h.t}</h3>
                  <p className="mt-2 text-sm text-zinc-500 leading-relaxed">{h.d}</p>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
